import { Grid } from "@mui/material";
import { useSuperAdminSuscripts } from "../../../context/SuperAdmin/SuscriptsContext";
import { Spinner } from "../../Loading/Spinner";
import HeaderSuscriptTable from "./HeadersSuscriptTable";
import CreateSuscriptModal from "./CreateSuscriptModal";
import SuscriptsTable from "./SuscriptsTable";
import EditSuscriptModal from "./EditSuscriptModal";
import DeleteSuscrModal from "../Users/Suscriptions/DeleteSuscrModal";

const SuscriptPanel = () => {
  const {
    isLoadingSuscriptions,
    isDeleting,
    toDeleteSuscr,
    handleDelete,
    assignToDeleteSuscr,
  } = useSuperAdminSuscripts();


  if (isLoadingSuscriptions) {
    return <Spinner msg="Cargando por favor espere..." />;
  }

  return (
    <>
      {/* Botón de crear suscripcion */}
      <Grid item>
        <HeaderSuscriptTable />
      </Grid>

      {/* Tabla de suscripciones */}
      <Grid item>
        <SuscriptsTable />
      </Grid>

      {/* Modal para crear suscripción */}
      <Grid item>
        <CreateSuscriptModal />
      </Grid>

      {/* Modal para editar suscripción */}
      <Grid item>
        <EditSuscriptModal />
      </Grid>

      {/* Modal para borrar suscripción */}
      <Grid item>
        <DeleteSuscrModal
          isDeleting={isDeleting}
          handleDelete={handleDelete}
          toDeleteSuscr={toDeleteSuscr}
          assignToDeleteSuscr={assignToDeleteSuscr}
          title="¿Quieres eliminar esta suscripción?"
          subtitle="Todos los usuarios anexados serán desuscritos"
        />
      </Grid>
    </>
  );
};

export default SuscriptPanel;
